import { render, staticRenderFns } from "./BusinessBlockchainPage.vue?vue&type=template&id=385b93c2&scoped=true"
import script from "./BusinessBlockchainPage.vue?vue&type=script&lang=js"
export * from "./BusinessBlockchainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b93c2",
  null
  
)

export default component.exports